export default __webpack_public_path__ + "static/media/carousel2.e6c6a90c.jpeg";